<template>
  <el-col class="fileupload-container" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
    <div v-if="!['GBR'].includes(formData.Country)">
      <h3 v-html="$t('personalDetails2.fileUpload.addressUploadHtml.upload_your_documents')"></h3>
      <p class="upload-dis" v-html="$t('personalDetails2.fileUpload.addressUploadHtml.noe')"></p>
      <div class="not_document_tip">
        <h4 v-html="$t('personalDetails2.fileUpload.addressUploadHtml.documents_not_ready')"></h4>
        <p v-html="$t('personalDetails2.fileUpload.addressUploadHtml.noe2')"></p>
      </div>
      <el-row class="upload_content">
        <el-col class="upload_button" :sm="24" :md="12" :lg="12">
        <div class="upload_button_item" v-for='(item,key,index) in imgModel'>
          <div class="upload_item">
            <label>{{$t(`personalDetails2.fileUpload.uploadFileArr.${index}.labelTxt`)}}</label>
            <el-upload
              :ref="key"
              :file-list="formData[key]"
              :action="uploadFilePath"
              :on-preview="handlePreview"
              :on-success="handleSuccess"
              :before-remove="beforeRemove"
              :multiple="false"
              :before-upload="beforeAvatarUpload"
              :data="currentUploadData"
              @click.native = saveParameData({modelName:key})
            >
            <div style="overflow:hidden;">{{item['fileList']}}</div>
              <el-button size="small" type="primary">{{$t('personalDetails2.fileUpload.imgtUpload')}}</el-button>
              <!-- <div slot="tip" class="el-form-item__error" v-if="item['imgIsRequired']&&!Boolean(formData[key][0])">请选择</div> -->
            </el-upload>
          </div>
        </div>
        <p style="float:right" v-html="$t('personalDetails2.fileUpload.addressUploadHtml.sizeLimit')"></p>
        </el-col>
        <el-col class="upload_tip" :sm="24" :md="12" :lg="12">
          <p><b v-html="proofOfIdentity"></b></p>
          <p v-if="country.includes(formData.Country)" v-html="$t('personalDetails2.fileUpload.addressUploadHtml.list1_new')"></p>
          <p v-else v-html="$t('personalDetails2.fileUpload.addressUploadHtml.list1')"></p>
          <p><b v-html='proofOfAddress'></b></p>
          <p v-html="$t('personalDetails2.fileUpload.addressUploadHtml.list2')"></p>
        </el-col>
      </el-row>
    </div>
    <p v-html="$t('personalDetails2.fileUpload.addressUploadHtml.strongTxt')"></p>
  </el-col>
</template>

<script>
import { mapState } from "vuex";
import Vue from "vue";
import { URL_UPLOAD, URL_DOWNLOAD } from "../api/api.js";


export default {
  props: ["formData"],
  data() {
    return {
      currentUploadData: {},
      downloadFilePath: URL_DOWNLOAD,
      uploadFilePath: URL_UPLOAD,
      uploadType: [
        "image/png",
        "image/gif",
        "image/jpeg",
        "image/webp",
        "application/pdf"
      ],
      country:['ALB','DZA','AGO','ARM','AZE','BLR','BEN','BOL','BIH','BFA','KHM','CPV','COL','CRI','CIV','DMA','DOM','SLV','GMB','GHA','GTM','GUY','HTI','HND','IRQ','JAM','KAZ','KEN','KGZ','LBN','LSO','MEX','MNG','NAM','NPL','NIC','NGA','PAK','PAN','PNG','PRY','RUS','RWA','SAU','SEN','SRB','LKA','TZA','TLS','TTO','TUR','UKR','URY','VNM'],
      imageIsUploaded: false,
      imgModel: {
        Doc_Front_Img: {
          imgIsRequired: false,
        },
        Doc_Back_Img: {
          imgIsRequired: false,
        },
        Proof_of_Address: {
          imgIsRequired: false,
        },
        Proof_of_Address_2: {
          imgIsRequired: false,
        },
        Other_Files: {
          imgIsRequired: false,
        }
      },
    };
  },
  watch: {
  },
  computed: {
    ...mapState(["LANGUAGE",'uploadFileType']),
    proofOfIdentity() {
      return this.getlang(["Doc_Front_Img", "Doc_Back_Img"],this.$t("personalDetails2.fileUpload.addressUploadHtml.header1"));
    },
    proofOfAddress() {
      return this.getlang(["Proof_of_Address", "Proof_of_Address_2"],this.$t("personalDetails2.fileUpload.addressUploadHtml.header2"));
    },
  },
  methods: {
    getlang(modelArr, lang) {
      // 处理带有变量的翻译段落
      let num = 0;
      this.uploadFileType.forEach(item => {
        if (modelArr.includes(item)) num++;
      });
      return lang.replace("$Logic", num);
    },
    saveParameData(val) {
      this.currentUploadData = val;
    },
    handlePreview(file, fileList) {
      // 点击文件文字
      console.log("点击文件名字");
    },
    handleSuccess(file,fileList) {
      // 上传成功
      this.formData[this.currentUploadData.modelName]=[];
      this.formData[this.currentUploadData.modelName].push({'name':fileList.name,'url':file.name})
    },
    beforeRemove(file, fileList) {
      // 删除文件前钩子函数
      let flag = this.imgModel[this.currentUploadData.modelName].imgIsRequired;
      if (flag) return false;
      // return this.$confirm(`确定移除 ${file.name}？`);
      this.formData[this.currentUploadData.modelName] = [];
      return true;
    },
    beforeAvatarUpload(file) {
      // 点击上传按钮
      const isJPG = this.uploadType.includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是gif/jpg/jpeg/png/webp格式!");
      }
      if (!isLt2M) {
        this.$message.error(this.$t('personalDetails2.fileUpload.addressUploadHtml.sizeLimit'));
      }
      return isJPG && isLt2M;
    }
  }
};
</script>

<style lang="scss">
.mobileType {
  .fileupload-container {
    padding-left: 10px;
    padding-right: 10px;
    .upload_button{
      padding-right: 0;
    }
  }
  .upload_tip {
    border-top: 1px solid #ddd;
    padding-top: 10px;
    margin-top: 10px;
  }
}
.pcType {
  .fileupload-container {
    padding-left: 20px;
    padding-right: 20px;
  }
  .upload_content {
    padding: 20px;
  }
  .upload_tip {
    border-left: 1px solid #ddd;
    padding-left: 20px;
  }
}
.fileupload-container {
  .not_document_tip {
    padding: 3px 10px 20px;
    text-align: center;
    background: #ddd;
    border-bottom: 2px solid #f1672a;
    p {
      margin: 0;
    }
  }
  .required {
    label::before {
      content: "*";
      color: #f2672a;
      margin-right: 4px;
    }
  }
  .upload_button {
    padding-top: 20px;
    padding-right: 20px;
    .upload_button_item{
      margin-bottom: 50px;
    }
    .upload_item {
      position: relative;
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      label {
        line-height: 32px;
      }
      .el-upload-list{
        position: absolute;
        left:0;
        width: 100%;
        li{
          margin-top: 0;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/fileupload.vue